import { PATH_APP } from './paths';
import React, { lazy } from 'react';
import { Redirect } from 'react-router-dom';
import DashboardLayout from 'src/layouts/DashboardLayout';

// ----------------------------------------------------------------------
const AppRoutes = {
  path: PATH_APP.root,
  layout: DashboardLayout,
  routes: [
    {
      exact: true,
      path: PATH_APP.general.dashboard,
      component: lazy(() => import('src/views/DashboardAppView'))
    },
    {
      exact: true,
      path: `${PATH_APP.general.dashboard}/:ClientID/:View?/:Stats?`,
      component: lazy(() => import('src/views/DashboardAppView'))
    },
    {
      exact: true,
      path: PATH_APP.general.profile,
      component: lazy(() => import('src/views/ProfileView'))
    },
    {
      exact: true,
      path: PATH_APP.root,
      component: () => <Redirect to={PATH_APP.general.dashboard} />
    },
    {
      exact: true,
      path: `${PATH_APP.general.lead}/:ClientID/:LeadID`,
      component: lazy(() =>
        import('src/views/DashboardAppView/RedirectLeadView')
      )
    },
    {
      component: () => <Redirect to="/404" />
    }
  ]
};

export default AppRoutes;
